function generateSrcString(videoTemplate, videoView) {
    return videoTemplate.replace('{view}', videoView);
}

export default function getProductVideoFromTemplate(videoTemplate, view) {
    return {
        url: generateSrcString(videoTemplate, view),
    };
}
